import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocTokenService {

  private issuer = {
    login: environment.apiUrl + '/doctorapi/login',
  };

  constructor() {}

  handleData(token: any) {
    localStorage.setItem('doctor_auth_token', token);
  }

  getToken() {
    return localStorage.getItem('doctor_auth_token');
  }

  // Verify the token
  isValidToken() {
    const token = this.getToken();
    if (token) {
      const payload = this.payload(token);
      // console.log(payload);
      if (payload) {
        return Object.values(this.issuer).indexOf(payload.iss) > -1
          ? true
          : false;
      }
    } else {
      return false;
    }
  }

  payload(token: any) {
    const jwtPayload = token.split('.')[1];
    return JSON.parse(atob(jwtPayload));
  }

  // User state based on valid token
  isLoggedIn() {
    return this.isValidToken();
  }

  // Remove token
  removeToken() {
    localStorage.removeItem('doctor_auth_token');
  }
}